import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-674d596c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex flex-row items-center justify-start w-full h-full pl-4 pr-12 text-white",
  stylee: "height: calc(2.55rem);"
}
const _hoisted_2 = { class: "text-gray-500 flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "  |  ", -1))
const _hoisted_4 = ["href"]

import { storageConfig } from "@/state/api/userState";
	import i18n from "@/lang/langs";

export default /*#__PURE__*/_defineComponent({
  __name: 'AppAuthFooter',
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, "© " + _toDisplayString(_unref(i18n)[_unref(storageConfig).lang]?.app.appName || "Jahagal Software") + " 2022 - " + _toDisplayString(new Date().getFullYear()), 1),
      _hoisted_3,
      _createElementVNode("a", {
        class: "text-accent opacity-60",
        href: _unref(i18n)[_unref(storageConfig).lang]?.app.urlAuthor || 'https://www.bzilee.me'
      }, _toDisplayString(_unref(i18n)[_unref(storageConfig).lang]?.app.author || " | Mfoum Group SARL"), 9, _hoisted_4)
    ])
  ]))
}
}

})